import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { Observable } from "rxjs";
import { environment } from "../../../../environments/environment";
import { ServiceCRUD } from "../../../shared/crud/ServiceCRUD";

@Injectable()
export class RelatorioOportunidadeService extends ServiceCRUD {
  private baseUrlService: string;
  public carregando = true;

  constructor(
    public httpClient: HttpClient,
    router: Router,
    protected toastr: ToastrService
  ) {
    super(httpClient, router);
    this.baseUrlService = environment.URL_API;
  }

  protected getURL(): string {
    return `${this.baseUrlService}/relatorio_oportunidade`;
  }

  public getDados(
    data_inicial?: any,
    data_final?: any,
    dealers?: any,
    status?: any
  ): Observable<any> {
    let params = new HttpParams();

    if (data_inicial != null) {
      params = params.set("data_inicial", data_inicial.toString());
    }
    if (data_final != null) {
      params = params.set("data_final", data_final.toString());
    }
    if (dealers != null) {
      params = params.set("dealers", dealers.toString());
    }
    if (status !== null && status !== undefined) {
      params = params.set("status", status.toString());
    }

    return this.httpClient.get<any>(
      `${this.baseUrlService + "/relatorio_oportunidade/"}`,
      {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          Authorization: JSON.parse(sessionStorage.getItem("currentUser"))
            .token,
        }),
        params,
      }
    );
  }
}
